import React, { useState, useRef } from 'react';
import { BACKEND_URL, apiFetch } from '../constants';

export default function UploadPage() {
  const [drag, setDrag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [opened, setOpened] = useState('');
  const inputRef = useRef(null);

  const tryLoadFolder = async (files) => {
    if (!files || files.length === 0) return;
    const rel = (files[0].webkitRelativePath || files[0].name);
    const folderName = rel.split('/')[0];
    setLoading(true);
    setError('');
    setOpened('');
    try {
      const res = await apiFetch(`${BACKEND_URL}/tasks/${encodeURIComponent(folderName)}/manifest`);
      if (!res.ok) throw new Error(
        'Folder not recognised. Drop the task UUID folder from the NetGen2 output directory.'
      );
      const manifest = await res.json();
      if (manifest.status !== 'ok') throw new Error('Invalid manifest.');
      const url = `?mode=result&task=${encodeURIComponent(folderName)}&taskName=${encodeURIComponent(folderName)}`;
      window.open(url, '_blank');
      setOpened(folderName);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>Open Existing Grid</h2>
      <div
        className={`upload-dropzone${drag ? ' drag' : ''}`}
        onClick={() => inputRef.current?.click()}
        onDrop={e => { e.preventDefault(); setDrag(false); tryLoadFolder(e.dataTransfer.files); }}
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
      >
        {loading
          ? <p>Loading…</p>
          : <p>Drop a NetGen2 output folder here, or click to browse</p>
        }
        <input
          ref={inputRef}
          type="file"
          webkitdirectory="true"
          directory="true"
          style={{ display: 'none' }}
          onChange={e => tryLoadFolder(e.target.files)}
        />
      </div>
      {error  && <p style={{ color: '#ef4444', fontSize: 13, marginTop: 10 }}>{error}</p>}
      {opened && <p style={{ color: '#4ade80', fontSize: 13, marginTop: 10 }}>Opened <b>{opened}</b> in a new tab.</p>}
    </div>
  );
}